import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";

export class LocationInventoryXREFBus extends BaseBus
{
    constructor(data: LocationInventoryXREFBus) {
        super(data);
    }

    CID(): any {
        return this.locationInventoryXrefId;
    }
    setId(id: any) {
        this.locationInventoryXrefId = id;
    }
    initialize(data: LocationInventoryXREFBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LocationInventoryXREFBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.fullDescription = data.fullDescription;
        this.inventoryId = data.inventoryId;
        this.inventoryDesc = data.inventoryDesc;

        //this.quantity = 1; 
        //this.qtyInStock = data..currentCost;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateUserId = userId;
        }
    }
    locationInventoryXrefId: any;
    locationId: any;
    inventoryId: any;
    number: string;
    model: string;
    inventoryName: string;
    fullDescription: string;
    price: number;
    updateUserId: string;
    insertDt: Date
    insertUserId: string;
    updateDt: Date;
    inventoryDesc: string;
createdDt : string;
createdUser : string;
locationName : string;
}
